module.exports = __webpack_public_path__ + "media/images/gallery/constellations/orion/ori_gal-aa99380b92346371b6791c6a5ae995a7.gif";